__turbopack_context__.v({
  "copy": "CardAnimatedIcon-module-scss-module__FqtUbq__copy",
  "fade-in": "CardAnimatedIcon-module-scss-module__FqtUbq__fade-in",
  "farmers": "CardAnimatedIcon-module-scss-module__FqtUbq__farmers",
  "headline": "CardAnimatedIcon-module-scss-module__FqtUbq__headline",
  "icon": "CardAnimatedIcon-module-scss-module__FqtUbq__icon",
  "inner": "CardAnimatedIcon-module-scss-module__FqtUbq__inner",
  "packaging": "CardAnimatedIcon-module-scss-module__FqtUbq__packaging",
  "root": "CardAnimatedIcon-module-scss-module__FqtUbq__root",
  "utensils": "CardAnimatedIcon-module-scss-module__FqtUbq__utensils",
});
